const protectingYourselfPhoneScamsAustralia = {
  slug: 'protecting-yourself-phone-scams-australia',
  title: 'Protecting yourself from phone scams in Australia',
  description:
    'Expert-style tips for Australians: spot scam calls, avoid common traps, and use lookup and reporting tools to stay safer.',
  category: 'guides',
  guideType: 'tips',
  readMinutes: 8,
  partnerTip: 'none',
  relatedSlugs: ['red-flags', 'what-not-to-do', 'report-phone-scam-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'Australian phone scams often impersonate the ATO, Services Australia, NBN providers, banks, and parcel couriers. The tactics are global; the brands are local.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Prevention habits',
    },
    {
      type: 'list',
      items: [
        'Let unknown numbers go to voicemail — legitimate callers usually leave a message',
        'Never share SMS codes or passwords with anyone who called you',
        'Hang up and call back on a number you find yourself (card, bill, official site)',
        'Register on the Do Not Call Register to reduce legal telemarketing',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Use community intelligence',
    },
    {
      type: 'paragraph',
      text: 'Before returning a missed call, search the number on WhoDatNumber. Multiple scam reports are a strong hint to block and report.',
    },
    {
      type: 'lookupCta',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Protect your accounts',
    },
    {
      type: 'paragraph',
      text: 'If a call felt like phishing, change passwords (starting with email), enable two-factor authentication, and consider a password manager.',
    },
    {
      type: 'link',
      to: '/learn/password-managers',
      label: 'Password managers guide',
    },
    {
      type: 'link',
      to: '/learn/after-a-scam-call',
      label: 'After a scam call checklist',
    },
    {
      type: 'link',
      to: '/learn/regions/au',
      label: 'Report to Scamwatch and other AU agencies',
    },
  ],
};

export default protectingYourselfPhoneScamsAustralia;

